import { Link } from "react-router-dom";
import { eur } from "@/lib/util";

const Img = ({ src, label }) => <img src={src} alt={label} title={label} className="h-7 w-11 rounded-[4px] border border-black/10 bg-white object-contain" />;

export const Visa = () => <Img src="/pay/visa.svg" label="Visa" />;
export const Mastercard = () => <Img src="/pay/mastercard.svg" label="Mastercard" />;
export const Amex = () => <Img src="/pay/amex.svg" label="American Express" />;
export const ApplePay = () => <Img src="/pay/m-applepay.svg" label="Apple Pay" />;
export const GooglePay = () => <Img src="/pay/m-googlepay.svg" label="Google Pay" />;
export const Bancontact = () => <Img src="/pay/m-bancontact.svg" label="Bancontact" />;
export const Satispay = () => <Img src="/pay/m-satispay.svg" label="Satispay" />;
export const PayByBank = () => <Img src="/pay/m-paybybank.svg" label="Pay by bank" />;
export const Billie = () => <Img src="/pay/m-billie.svg" label="Billie" />;
export const Klarna = ({ className = "h-7" }) => <img src="/pay/m-klarna.svg" alt="Klarna" className={`${className} w-auto rounded-[6px]`} data-testid="klarna-logo" />;

export const PAY_LOGOS = [Visa, Mastercard, ApplePay, GooglePay, Klarna];

export const PayLogosRow = ({ className = "", dark = false }) => (
  <div className={`flex flex-wrap items-center gap-1.5 ${className}`} data-testid="payment-logos">
    {PAY_LOGOS.map((L, i) => <span key={i} className={dark ? "rounded-[4px] ring-1 ring-white/25" : ""}><L className="h-7" /></span>)}
  </div>
);

export const KlarnaLine = ({ className = "" }) => (
  <div className={`flex items-center gap-3 rounded-md border border-[#f0d9a8] bg-[#FBF7EC] px-3.5 py-2.5 text-sm ${className}`} data-testid="klarna-line">
    <Klarna className="h-6 shrink-0" />
    <p className="leading-snug"><b>Payez en 3 fois sans frais</b> avec Klarna <span className="text-black/50">· selon éligibilité</span></p>
  </div>
);

export const KlarnaBand = () => (
  <div className="relative bg-[#FBF7EC] border-b border-[#ead9ac]" data-testid="klarna-band">
    <div className="container-x py-2.5 flex items-center justify-center gap-3 sm:gap-4 text-center">
      <Klarna className="h-7 shrink-0" />
      <p className="text-[12px] sm:text-sm text-black/80 leading-snug"><b className="font-semibold text-black">Paiement en plusieurs fois sans frais</b> avec Klarna<span className="hidden sm:inline text-black/50"> · à la validation de votre commande</span></p>
      <Link to="/faq" className="hidden md:inline text-[11px] uppercase tracking-[0.18em] text-[#8A6314] underline underline-offset-4 hover:text-black shrink-0" data-testid="klarna-band-link">En savoir plus</Link>
    </div>
  </div>
);

const KLARNA_3X_MIN = 1;
export const Klarna3x = ({ amount, big = false }) => !(amount >= KLARNA_3X_MIN) ? null : (
  <p className={`flex items-center gap-1.5 text-black/65 ${big ? "text-sm mt-2" : "text-[11px] mt-1"}`} data-testid="klarna-3x"><span>ou 3 × <b className="text-black">{eur(amount / 3)}</b> avec</span><Klarna className={big ? "h-5" : "h-4"} /></p>
);
